import gql from "graphql-tag";

export const CREATE_TEMPLATE_COSTUME_ATTRIBUTE = gql`
  mutation CreateCostumeAttribute($data: CostumeAttributeCreateInput!) {
    createCostumeAttribute(data: $data) {
      id
    }
  }
`;
